/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class WarehouseVisualServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 库存统计
     * @param dto dto
     * @return OK
     */
    getStockStatistics(dto: PageStockStatisticsDTO): Promise<IPageOfStockStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/visual/get-stock-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockStatistics(_response);
        });
    }

    protected processGetStockStatistics(response: AxiosResponse): Promise<IPageOfStockStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockStatisticsVO.fromJS(resultData200) : new IPageOfStockStatisticsVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockStatisticsVO>(<any>null);
    }
}

export class WarehouseAreaServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增库区
     * @param dto dto
     * @return OK
     */
    createWarehouseArea(dto: WarehouseAreaSubmitDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWarehouseArea(_response);
        });
    }

    protected processCreateWarehouseArea(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 导出数据
     * @param exportDTO exportDTO
     * @return OK
     */
    export(exportDTO: ExportDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导出模板
     * @param exportTemplateDTO exportTemplateDTO
     * @return OK
     */
    exportMaterialTemplate(exportTemplateDTO: ExportTemplateDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/export/template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportTemplateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportMaterialTemplate(_response);
        });
    }

    protected processExportMaterialTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 获取维修和保养的单号
     * @return OK
     */
    getTpmRepairAndMaintainNumber(): Promise<TpmNumberVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/getTpmRepairAndMaintainNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTpmRepairAndMaintainNumber(_response);
        });
    }

    protected processGetTpmRepairAndMaintainNumber(response: AxiosResponse): Promise<TpmNumberVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TpmNumberVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<TpmNumberVO[]>(<any>null);
    }

    /**
     * 导入物料数据
     * @param areaId (optional) 库区Id
     * @param file (optional) file
     * @return OK
     */
    importMaterialVerification(areaId: string | null | undefined, file: FileParameter | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/import?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportMaterialVerification(_response);
        });
    }

    protected processImportMaterialVerification(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询库区列表
     * @param keyword (optional) 关键词
     * @return OK
     */
    listWarehouseArea(keyword: string | null | undefined): Promise<WarehouseAreaVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/list?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListWarehouseArea(_response);
        });
    }

    protected processListWarehouseArea(response: AxiosResponse): Promise<WarehouseAreaVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseAreaVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseAreaVO[]>(<any>null);
    }

    /**
     * OpenApi新增库区
     * @param dto dto
     * @return OK
     */
    createWarehouseAreaForOpenApi(dto: WarehouseAreaAddOpenApiDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWarehouseAreaForOpenApi(_response);
        });
    }

    protected processCreateWarehouseAreaForOpenApi(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * OpenApi编辑库区
     * @param dto dto
     * @return OK
     */
    updateWarehouseAreaForOpenApi(dto: WarehouseAreaSubmitOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWarehouseAreaForOpenApi(_response);
        });
    }

    protected processUpdateWarehouseAreaForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询库区详情
     * @param id id
     * @return OK
     */
    getWarehouseArea(id: string): Promise<WarehouseAreaVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWarehouseArea(_response);
        });
    }

    protected processGetWarehouseArea(response: AxiosResponse): Promise<WarehouseAreaVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WarehouseAreaVO.fromJS(resultData200) : new WarehouseAreaVO();
            return result200;
        }
        return Promise.resolve<WarehouseAreaVO>(<any>null);
    }

    /**
     * 编辑库区
     * @param dto dto
     * @param id id
     * @return OK
     */
    updateWarehouseArea(dto: WarehouseAreaSubmitDTO, id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWarehouseArea(_response);
        });
    }

    protected processUpdateWarehouseArea(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除库区
     * @param id (optional) 库区id
     * @return OK
     */
    deleteWarehouseArea(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-areas/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWarehouseArea(_response);
        });
    }

    protected processDeleteWarehouseArea(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WarehouseLocationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建库位
     * @param dto dto
     * @return OK
     */
    createWarehouseLocation(dto: WarehouseLocationSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWarehouseLocation(_response);
        });
    }

    protected processCreateWarehouseLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 更改库位信息
     * @param dto dto
     * @return OK
     */
    updateWarehouseLocation(dto: WarehouseLocationUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWarehouseLocation(_response);
        });
    }

    protected processUpdateWarehouseLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 根据Code查询库位详情
     * @param areaId (optional) 库区id
     * @param locationCode (optional) 库位编码
     * @return OK
     */
    getWarehouseLocationByCode(areaId: string | null | undefined, locationCode: string | null | undefined): Promise<WarehouseLocationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/code/{locationCode}?";
        if (locationCode !== null && locationCode !== undefined)
        url_ = url_.replace("{locationCode}", encodeURIComponent("" + locationCode)); 
        else
            url_ = url_.replace("/{locationCode}", "");
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWarehouseLocationByCode(_response);
        });
    }

    protected processGetWarehouseLocationByCode(response: AxiosResponse): Promise<WarehouseLocationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WarehouseLocationVO.fromJS(resultData200) : new WarehouseLocationVO();
            return result200;
        }
        return Promise.resolve<WarehouseLocationVO>(<any>null);
    }

    /**
     * 查询库位列表
     * @param id (optional) 库区id
     * @param keyWord (optional) keyWord
     * @return OK
     */
    listWarehouseLocation(id: string | null | undefined, keyWord: string | null | undefined): Promise<WarehouseLocationListVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/list?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListWarehouseLocation(_response);
        });
    }

    protected processListWarehouseLocation(response: AxiosResponse): Promise<WarehouseLocationListVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationListVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseLocationListVO[]>(<any>null);
    }

    /**
     * 查询库位列表(优先显示已绑定)
     * @param id (optional) 库区id
     * @param keyWord (optional) 关键词
     * @param materialId (optional) 物料Id
     * @return OK
     */
    listWarehouseLocationByMaterial(id: string | null | undefined, keyWord: string | null | undefined, materialId: string | null | undefined): Promise<WarehouseLocationListVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/list-by-material?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListWarehouseLocationByMaterial(_response);
        });
    }

    protected processListWarehouseLocationByMaterial(response: AxiosResponse): Promise<WarehouseLocationListVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationListVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseLocationListVO[]>(<any>null);
    }

    /**
     * OpenApi新建库位
     * @param dto dto
     * @return OK
     */
    createWarehouseLocationForOpenApi(dto: WarehouseLocationAddOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWarehouseLocationForOpenApi(_response);
        });
    }

    protected processCreateWarehouseLocationForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * OpenApi更改库位信息
     * @param dto dto
     * @return OK
     */
    updateWarehouseLocationForOpenApi(dto: WarehouseLocationUpdateOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/open-api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateWarehouseLocationForOpenApi(_response);
        });
    }

    protected processUpdateWarehouseLocationForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询库位
     * @param current (optional) 当前页
     * @param id (optional) 库区id
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageWarehouseLocation(current: number | null | undefined, id: string | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfWarehouseLocationListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/page?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWarehouseLocation(_response);
        });
    }

    protected processPageWarehouseLocation(response: AxiosResponse): Promise<IPageOfWarehouseLocationListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWarehouseLocationListVO.fromJS(resultData200) : new IPageOfWarehouseLocationListVO();
            return result200;
        }
        return Promise.resolve<IPageOfWarehouseLocationListVO>(<any>null);
    }

    /**
     * 查询库位详情
     * @param id (optional) 库位id
     * @return OK
     */
    getWarehouseLocation(id: string | null | undefined): Promise<WarehouseLocationVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWarehouseLocation(_response);
        });
    }

    protected processGetWarehouseLocation(response: AxiosResponse): Promise<WarehouseLocationVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WarehouseLocationVO.fromJS(resultData200) : new WarehouseLocationVO();
            return result200;
        }
        return Promise.resolve<WarehouseLocationVO>(<any>null);
    }

    /**
     * 删除库位
     * @param id (optional) 库位id
     * @return OK
     */
    deleteWarehouseLocation(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-locations/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWarehouseLocation(_response);
        });
    }

    protected processDeleteWarehouseLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WarehouseMaterialStockServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 库位关联物料
     * @param dto dto
     * @return OK
     */
    createWarehouseMaterialStock(dto: WarehouseMaterialStockListDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateWarehouseMaterialStock(_response);
        });
    }

    protected processCreateWarehouseMaterialStock(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 模糊查询库存物料（包含库区库位）
     * @param materialQueryDTO materialQueryDTO
     * @return OK
     */
    getStockMaterial(materialQueryDTO: MaterialQueryDTO): Promise<WarehouseStockMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/get-stock-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockMaterial(_response);
        });
    }

    protected processGetStockMaterial(response: AxiosResponse): Promise<WarehouseStockMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseStockMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseStockMaterialVO[]>(<any>null);
    }

    /**
     * 模糊查询库存物料（不包含库区库位）
     * @param materialQueryDTO materialQueryDTO
     * @return OK
     */
    getStockMaterialNoLocation(materialQueryDTO: MaterialQueryDTO): Promise<WarehouseStockMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/get-stock-material-no-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materialQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockMaterialNoLocation(_response);
        });
    }

    protected processGetStockMaterialNoLocation(response: AxiosResponse): Promise<WarehouseStockMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseStockMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseStockMaterialVO[]>(<any>null);
    }

    /**
     * 库存统计
     * @param dto dto
     * @return OK
     */
    getStockStatistics(dto: PageStockStatisticsDTO): Promise<IPageOfStockStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/get-stock-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockStatistics(_response);
        });
    }

    protected processGetStockStatistics(response: AxiosResponse): Promise<IPageOfStockStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockStatisticsVO.fromJS(resultData200) : new IPageOfStockStatisticsVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockStatisticsVO>(<any>null);
    }

    /**
     * 列出相应库区
     * @param materialId (optional) 物料id
     * @return OK
     */
    listAreaByMaterialId(materialId: string | null | undefined): Promise<WarehouseAreaVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-all-area?";
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAreaByMaterialId(_response);
        });
    }

    protected processListAreaByMaterialId(response: AxiosResponse): Promise<WarehouseAreaVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseAreaVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseAreaVO[]>(<any>null);
    }

    /**
     * 列出相应库位
     * @param areaId areaId
     * @param keyword (optional) 关键词
     * @param materialId (optional) 物料id
     * @return OK
     */
    listLocationByMaterialIdAndAreaId(areaId: string, keyword: string | null | undefined, materialId: string | null | undefined): Promise<WarehouseLocationVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-all-location?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined and cannot be null.");
        else
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListLocationByMaterialIdAndAreaId(_response);
        });
    }

    protected processListLocationByMaterialIdAndAreaId(response: AxiosResponse): Promise<WarehouseLocationVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseLocationVO[]>(<any>null);
    }

    /**
     * 列出相应库位（优先选择绑定库位）
     * @param areaId areaId
     * @param keyword (optional) 关键词
     * @param materialId (optional) 物料id
     * @return OK
     */
    listLocationByMaterial(areaId: string, keyword: string | null | undefined, materialId: string | null | undefined): Promise<WarehouseLocationVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-all-location-by-material?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined and cannot be null.");
        else
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListLocationByMaterial(_response);
        });
    }

    protected processListLocationByMaterial(response: AxiosResponse): Promise<WarehouseLocationVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseLocationVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseLocationVO[]>(<any>null);
    }

    /**
     * 列出所有物料
     * @param areaId (optional) 库区id
     * @param keyword (optional) 关键词
     * @return OK
     */
    listAllMaterial(areaId: string | null | undefined, keyword: string | null | undefined): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-all-material?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAllMaterial(_response);
        });
    }

    protected processListAllMaterial(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 列出所有物料(备品备件出库)
     * @param areaId (optional) 库区id
     * @param keyword (optional) 关键词
     * @return OK
     */
    listAllMaterialForParts(areaId: string | null | undefined, keyword: string | null | undefined): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-all-material-for-parts?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAllMaterialForParts(_response);
        });
    }

    protected processListAllMaterialForParts(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 查询库位物料列表
     * @param locationId (optional) 库位id
     * @param materialId (optional) materialId
     * @return OK
     */
    listWarehouseMaterialStock(locationId: string | null | undefined, materialId: string | null | undefined): Promise<WarehouseMaterialStockListVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/list-material?";
        if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListWarehouseMaterialStock(_response);
        });
    }

    protected processListWarehouseMaterialStock(response: AxiosResponse): Promise<WarehouseMaterialStockListVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseMaterialStockListVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WarehouseMaterialStockListVO[]>(<any>null);
    }

    /**
     * 列出所有出库物料
     * @param areaId (optional) 库区id
     * @param barCode (optional) 物料条码
     * @return OK
     */
    listAllMaterialByBarCode(areaId: string | null | undefined, barCode: string | null | undefined): Promise<MaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/mobile/list-all-material?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (barCode !== undefined)
            url_ += "barCode=" + encodeURIComponent("" + barCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAllMaterialByBarCode(_response);
        });
    }

    protected processListAllMaterialByBarCode(response: AxiosResponse): Promise<MaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<MaterialVo[]>(<any>null);
    }

    /**
     * 分页查询库位物料列表
     * @param current (optional) 当前页
     * @param locationId (optional) 库位id
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageWarehouseMaterialStock(current: number | null | undefined, locationId: string | null | undefined, size: number | null | undefined): Promise<IPageOfWarehouseMaterialStockListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/page-material?";
        if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWarehouseMaterialStock(_response);
        });
    }

    protected processPageWarehouseMaterialStock(response: AxiosResponse): Promise<IPageOfWarehouseMaterialStockListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWarehouseMaterialStockListVO.fromJS(resultData200) : new IPageOfWarehouseMaterialStockListVO();
            return result200;
        }
        return Promise.resolve<IPageOfWarehouseMaterialStockListVO>(<any>null);
    }

    /**
     * 删除关联物料
     * @param id (optional) 库位物料库存id
     * @return OK
     */
    deleteWarehouseMaterialStock(id: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse-material-stocks/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWarehouseMaterialStock(_response);
        });
    }

    protected processDeleteWarehouseMaterialStock(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WarehouseMaterialInventoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出
     * @param areaId (optional) 库区Id
     * @param keyWord (optional) 关键词
     * @return OK
     */
    exportProduct(areaId: string | null | undefined, keyWord: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/export?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 导入
     * @param file (optional) file
     * @return OK
     */
    importWarehouseMaterialInventory(file: FileParameter | null | undefined): Promise<WarehouseMaterialInventoryExportResult> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/import-test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportWarehouseMaterialInventory(_response);
        });
    }

    protected processImportWarehouseMaterialInventory(response: AxiosResponse): Promise<WarehouseMaterialInventoryExportResult> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WarehouseMaterialInventoryExportResult.fromJS(resultData200) : new WarehouseMaterialInventoryExportResult();
            return result200;
        }
        return Promise.resolve<WarehouseMaterialInventoryExportResult>(<any>null);
    }

    /**
     * 动态导入
     * @param file (optional) file
     * @return OK
     */
    importWarehouseMaterialInventoryDynamic(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/import-test-dynamic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportWarehouseMaterialInventoryDynamic(_response);
        });
    }

    protected processImportWarehouseMaterialInventoryDynamic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 盘点
     * @param warehouseMaterialInventoryDTO warehouseMaterialInventoryDTO
     * @return OK
     */
    inventory(warehouseMaterialInventoryDTO: WarehouseMaterialInventoryDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/inventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(warehouseMaterialInventoryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInventory(_response);
        });
    }

    protected processInventory(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询物料盘库库存
     * @param areaId (optional) 库区id
     * @param current (optional) 当前页
     * @param materialId (optional) 物料Id
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageWarehouseMaterialInventory(areaId: string | null | undefined, current: number | null | undefined, materialId: string | null | undefined, size: number | null | undefined): Promise<IPageOfWarehouseMaterialInventoryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/inventory-page?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWarehouseMaterialInventory(_response);
        });
    }

    protected processPageWarehouseMaterialInventory(response: AxiosResponse): Promise<IPageOfWarehouseMaterialInventoryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWarehouseMaterialInventoryVO.fromJS(resultData200) : new IPageOfWarehouseMaterialInventoryVO();
            return result200;
        }
        return Promise.resolve<IPageOfWarehouseMaterialInventoryVO>(<any>null);
    }

    /**
     * 按库位查询物料
     * @param areaId (optional) 库区id
     * @param current (optional) 当前页
     * @param locationId (optional) 库位id
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageLocationMaterialInventory(areaId: string | null | undefined, current: number | null | undefined, locationId: string | null | undefined, size: number | null | undefined): Promise<IPageOfWarehouseMaterialInventoryVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/inventory-page-location?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageLocationMaterialInventory(_response);
        });
    }

    protected processPageLocationMaterialInventory(response: AxiosResponse): Promise<IPageOfWarehouseMaterialInventoryVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWarehouseMaterialInventoryVO.fromJS(resultData200) : new IPageOfWarehouseMaterialInventoryVO();
            return result200;
        }
        return Promise.resolve<IPageOfWarehouseMaterialInventoryVO>(<any>null);
    }

    /**
     * 分页库区下物料
     * @param areaId (optional) 库区id
     * @param current (optional) 当前页
     * @param keyWord (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageWarehouseMaterialInventoryForArea(areaId: string | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfWarehouseMaterialInventoryListVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/page?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageWarehouseMaterialInventoryForArea(_response);
        });
    }

    protected processPageWarehouseMaterialInventoryForArea(response: AxiosResponse): Promise<IPageOfWarehouseMaterialInventoryListVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWarehouseMaterialInventoryListVO.fromJS(resultData200) : new IPageOfWarehouseMaterialInventoryListVO();
            return result200;
        }
        return Promise.resolve<IPageOfWarehouseMaterialInventoryListVO>(<any>null);
    }

    /**
     * 同步
     * @param areaId (optional) 库区Id
     * @return OK
     */
    sync(areaId: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-warehouse')+ "/warehouse_material_inventory/sync?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSync(_response);
        });
    }

    protected processSync(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ExportDTO implements IExportDTO {
    /** 库区Id */
    areaId!: string | undefined;

    constructor(data?: IExportDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
        }
    }

    static fromJS(data: any): ExportDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        return data; 
    }
}

export interface IExportDTO {
    /** 库区Id */
    areaId: string | undefined;
}

export class ExportTemplateDTO implements IExportTemplateDTO {
    /** 库区Id */
    areaId!: string | undefined;

    constructor(data?: IExportTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
        }
    }

    static fromJS(data: any): ExportTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        return data; 
    }
}

export interface IExportTemplateDTO {
    /** 库区Id */
    areaId: string | undefined;
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfStockStatisticsVO implements IIPageOfStockStatisticsVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockStatisticsVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockStatisticsVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockStatisticsVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockStatisticsVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWarehouseLocationListVO implements IIPageOfWarehouseLocationListVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WarehouseLocationListVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWarehouseLocationListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WarehouseLocationListVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWarehouseLocationListVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWarehouseLocationListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWarehouseLocationListVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WarehouseLocationListVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWarehouseMaterialInventoryListVO implements IIPageOfWarehouseMaterialInventoryListVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WarehouseMaterialInventoryListVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWarehouseMaterialInventoryListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WarehouseMaterialInventoryListVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWarehouseMaterialInventoryListVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWarehouseMaterialInventoryListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWarehouseMaterialInventoryListVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WarehouseMaterialInventoryListVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWarehouseMaterialInventoryVO implements IIPageOfWarehouseMaterialInventoryVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WarehouseMaterialInventoryVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWarehouseMaterialInventoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WarehouseMaterialInventoryVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWarehouseMaterialInventoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWarehouseMaterialInventoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWarehouseMaterialInventoryVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WarehouseMaterialInventoryVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWarehouseMaterialStockListVO implements IIPageOfWarehouseMaterialStockListVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WarehouseMaterialStockListVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWarehouseMaterialStockListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WarehouseMaterialStockListVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWarehouseMaterialStockListVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWarehouseMaterialStockListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWarehouseMaterialStockListVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WarehouseMaterialStockListVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class MaterialQueryDTO implements IMaterialQueryDTO {
    /** 关键词 */
    keyWord!: string | undefined;
    /** 物料属性 */
    property!: number | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;

    constructor(data?: IMaterialQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyWord = data["keyWord"];
            this.property = data["property"];
            this.typeId = data["typeId"];
        }
    }

    static fromJS(data: any): MaterialQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyWord"] = this.keyWord;
        data["property"] = this.property;
        data["typeId"] = this.typeId;
        return data; 
    }
}

export interface IMaterialQueryDTO {
    /** 关键词 */
    keyWord: string | undefined;
    /** 物料属性 */
    property: number | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
}

export class MaterialVo implements IMaterialVo {
    /** 所属库位Id */
    areaId!: string | undefined;
    /** 所属库区名称 */
    areaName!: string | undefined;
    /** 物料条码 */
    barCode!: string | undefined;
    /** 物料编码 */
    code!: string | undefined;
    /** 显示编码 */
    displayCode!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheckName!: string | undefined;
    /** 所属库位Id */
    locationId!: string | undefined;
    /** 所属库区名称 */
    locationName!: string | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.displayCode = data["displayCode"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.isMustCheckName = data["isMustCheckName"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.lowerLimit = data["lowerLimit"];
            this.name = data["name"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockOutNum = data["stockOutNum"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): MaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["displayCode"] = this.displayCode;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["isMustCheckName"] = this.isMustCheckName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["lowerLimit"] = this.lowerLimit;
        data["name"] = this.name;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockOutNum"] = this.stockOutNum;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IMaterialVo {
    /** 所属库位Id */
    areaId: string | undefined;
    /** 所属库区名称 */
    areaName: string | undefined;
    /** 物料条码 */
    barCode: string | undefined;
    /** 物料编码 */
    code: string | undefined;
    /** 显示编码 */
    displayCode: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheckName: string | undefined;
    /** 所属库位Id */
    locationId: string | undefined;
    /** 所属库区名称 */
    locationName: string | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class PageStockStatisticsDTO implements IPageStockStatisticsDTO {
    /** 库区ID */
    areaId!: string;
    /** 关键字查询 */
    keyWord!: string | undefined;
    /** 分页信息 */
    query!: Query;

    constructor(data?: IPageStockStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.query = new Query();
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.keyWord = data["keyWord"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : new Query();
        }
    }

    static fromJS(data: any): PageStockStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PageStockStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["keyWord"] = this.keyWord;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPageStockStatisticsDTO {
    /** 库区ID */
    areaId: string;
    /** 关键字查询 */
    keyWord: string | undefined;
    /** 分页信息 */
    query: Query;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

/** 物料库存统计信息 */
export class StockStatisticsVO implements IStockStatisticsVO {
    /** 库区id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    /** 批次号 */
    batchCode!: string | undefined;
    /** 是否缺料 */
    isLack!: number | undefined;
    /** 库位id */
    locationId!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库存数量 */
    locationNum!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 物料属性：物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它（前端匹配） */
    property!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 规格尺寸 */
    standardModel!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IStockStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.batchCode = data["batchCode"];
            this.isLack = data["isLack"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): StockStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["batchCode"] = this.batchCode;
        data["isLack"] = this.isLack;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 物料库存统计信息 */
export interface IStockStatisticsVO {
    /** 库区id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    /** 批次号 */
    batchCode: string | undefined;
    /** 是否缺料 */
    isLack: number | undefined;
    /** 库位id */
    locationId: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库存数量 */
    locationNum: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 物料属性：物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它（前端匹配） */
    property: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 规格尺寸 */
    standardModel: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

export class TpmNumberVO implements ITpmNumberVO {
    /** 维修单号/保养单号 */
    code!: string | undefined;
    id!: string | undefined;
    /** 1 维修   2 保养 */
    type!: number | undefined;

    constructor(data?: ITpmNumberVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): TpmNumberVO {
        data = typeof data === 'object' ? data : {};
        let result = new TpmNumberVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["type"] = this.type;
        return data; 
    }
}

export interface ITpmNumberVO {
    /** 维修单号/保养单号 */
    code: string | undefined;
    id: string | undefined;
    /** 1 维修   2 保养 */
    type: number | undefined;
}

/** 库区信息 */
export class WarehouseAreaAddOpenApiDTO implements IWarehouseAreaAddOpenApiDTO {
    /** 库区编码 */
    code!: string;
    /** 库区名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseAreaAddOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseAreaAddOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseAreaAddOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库区信息 */
export interface IWarehouseAreaAddOpenApiDTO {
    /** 库区编码 */
    code: string;
    /** 库区名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

/** 库区信息 */
export class WarehouseAreaSubmitDTO implements IWarehouseAreaSubmitDTO {
    /** 库区编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 库区名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseAreaSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseAreaSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseAreaSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库区信息 */
export interface IWarehouseAreaSubmitDTO {
    /** 库区编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 库区名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 库区信息 */
export class WarehouseAreaSubmitOpenApiDTO implements IWarehouseAreaSubmitOpenApiDTO {
    /** 库区id */
    id!: string;
    /** 库区名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseAreaSubmitOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseAreaSubmitOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseAreaSubmitOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库区信息 */
export interface IWarehouseAreaSubmitOpenApiDTO {
    /** 库区id */
    id: string;
    /** 库区名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

/** 库区信息 */
export class WarehouseAreaVO implements IWarehouseAreaVO {
    /** 库区编码 */
    code!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 本级标识 */
    levelNum!: string | undefined;
    /** 库区名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseAreaVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.levelNum = data["levelNum"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseAreaVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseAreaVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["levelNum"] = this.levelNum;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库区信息 */
export interface IWarehouseAreaVO {
    /** 库区编码 */
    code: string | undefined;
    /** id */
    id: string | undefined;
    /** 本级标识 */
    levelNum: string | undefined;
    /** 库区名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 库位信息 */
export class WarehouseLocationAddOpenApiDTO implements IWarehouseLocationAddOpenApiDTO {
    /** 库区id */
    areaId!: string;
    /** 库位编码 */
    code!: string;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind!: number | undefined;
    /** 库位名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseLocationAddOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.code = data["code"];
            this.isBind = data["isBind"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseLocationAddOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationAddOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["code"] = this.code;
        data["isBind"] = this.isBind;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库位信息 */
export interface IWarehouseLocationAddOpenApiDTO {
    /** 库区id */
    areaId: string;
    /** 库位编码 */
    code: string;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind: number | undefined;
    /** 库位名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

/** 库位列表信息 */
export class WarehouseLocationListVO implements IWarehouseLocationListVO {
    /** 库位id */
    id!: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind!: number | undefined;
    /** 本级标识 */
    levelNum!: string | undefined;
    plevelNum!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 库区编码 */
    warehouseAreaCode!: string | undefined;
    /** 库区名称 */
    warehouseAreaName!: string | undefined;
    /** 库位编码 */
    warehouseLocationCode!: string | undefined;
    /** 库位名称 */
    warehouseLocationName!: string | undefined;

    constructor(data?: IWarehouseLocationListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isBind = data["isBind"];
            this.levelNum = data["levelNum"];
            this.plevelNum = data["plevelNum"];
            this.remark = data["remark"];
            this.warehouseAreaCode = data["warehouseAreaCode"];
            this.warehouseAreaName = data["warehouseAreaName"];
            this.warehouseLocationCode = data["warehouseLocationCode"];
            this.warehouseLocationName = data["warehouseLocationName"];
        }
    }

    static fromJS(data: any): WarehouseLocationListVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBind"] = this.isBind;
        data["levelNum"] = this.levelNum;
        data["plevelNum"] = this.plevelNum;
        data["remark"] = this.remark;
        data["warehouseAreaCode"] = this.warehouseAreaCode;
        data["warehouseAreaName"] = this.warehouseAreaName;
        data["warehouseLocationCode"] = this.warehouseLocationCode;
        data["warehouseLocationName"] = this.warehouseLocationName;
        return data; 
    }
}

/** 库位列表信息 */
export interface IWarehouseLocationListVO {
    /** 库位id */
    id: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind: number | undefined;
    /** 本级标识 */
    levelNum: string | undefined;
    plevelNum: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 库区编码 */
    warehouseAreaCode: string | undefined;
    /** 库区名称 */
    warehouseAreaName: string | undefined;
    /** 库位编码 */
    warehouseLocationCode: string | undefined;
    /** 库位名称 */
    warehouseLocationName: string | undefined;
}

/** 库位信息 */
export class WarehouseLocationSubmitDTO implements IWarehouseLocationSubmitDTO {
    /** 库区id */
    areaId!: string | undefined;
    areaName!: string | undefined;
    /** 库位编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind!: number | undefined;
    /** 库位名称 */
    name!: string | undefined;
    plevelNum!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseLocationSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.isBind = data["isBind"];
            this.name = data["name"];
            this.plevelNum = data["plevelNum"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseLocationSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["isBind"] = this.isBind;
        data["name"] = this.name;
        data["plevelNum"] = this.plevelNum;
        data["remark"] = this.remark;
        return data; 
    }
}

/** 库位信息 */
export interface IWarehouseLocationSubmitDTO {
    /** 库区id */
    areaId: string | undefined;
    areaName: string | undefined;
    /** 库位编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind: number | undefined;
    /** 库位名称 */
    name: string | undefined;
    plevelNum: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class WarehouseLocationUpdateDTO implements IWarehouseLocationUpdateDTO {
    /** 库位编码 */
    code!: string | undefined;
    /** 库位id */
    id!: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind!: number | undefined;
    /** 库位名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseLocationUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isBind = data["isBind"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseLocationUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isBind"] = this.isBind;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IWarehouseLocationUpdateDTO {
    /** 库位编码 */
    code: string | undefined;
    /** 库位id */
    id: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind: number | undefined;
    /** 库位名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class WarehouseLocationUpdateOpenApiDTO implements IWarehouseLocationUpdateOpenApiDTO {
    /** 库位id */
    id!: string;
    /** 库位名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseLocationUpdateOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseLocationUpdateOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationUpdateOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IWarehouseLocationUpdateOpenApiDTO {
    /** 库位id */
    id: string;
    /** 库位名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class WarehouseLocationVO implements IWarehouseLocationVO {
    /** 库区id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    /** 库位编码 */
    code!: string | undefined;
    /** 库位id */
    id!: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind!: number | undefined;
    /** 本级标识 */
    levelNum!: string | undefined;
    /** 库位名称 */
    name!: string | undefined;
    plevelNum!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseLocationVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.code = data["code"];
            this.id = data["id"];
            this.isBind = data["isBind"];
            this.levelNum = data["levelNum"];
            this.name = data["name"];
            this.plevelNum = data["plevelNum"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseLocationVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseLocationVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["code"] = this.code;
        data["id"] = this.id;
        data["isBind"] = this.isBind;
        data["levelNum"] = this.levelNum;
        data["name"] = this.name;
        data["plevelNum"] = this.plevelNum;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IWarehouseLocationVO {
    /** 库区id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    /** 库位编码 */
    code: string | undefined;
    /** 库位id */
    id: string | undefined;
    /** 是否绑定物料，0-不绑定，1-绑定 */
    isBind: number | undefined;
    /** 本级标识 */
    levelNum: string | undefined;
    /** 库位名称 */
    name: string | undefined;
    plevelNum: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class WarehouseMaterialInventoryAddDTO implements IWarehouseMaterialInventoryAddDTO {
    /** 所属库区id */
    areaId!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum!: string | undefined;
    /** 盘点时间 */
    inventoryTime!: Date | undefined;
    /** 盘点人员 */
    inventoryUser!: string | undefined;
    /** 所属库位id */
    locationId!: string | undefined;
    /** 库位物料数量 */
    locationNum!: number | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IWarehouseMaterialInventoryAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.id = data["id"];
            this.inventoryNum = data["inventoryNum"];
            this.inventoryTime = data["inventoryTime"] ? new Date(data["inventoryTime"].toString()) : <any>undefined;
            this.inventoryUser = data["inventoryUser"];
            this.locationId = data["locationId"];
            this.locationNum = data["locationNum"];
            this.materialId = data["materialId"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): WarehouseMaterialInventoryAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialInventoryAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["id"] = this.id;
        data["inventoryNum"] = this.inventoryNum;
        data["inventoryTime"] = this.inventoryTime ? this.inventoryTime.toISOString() : <any>undefined;
        data["inventoryUser"] = this.inventoryUser;
        data["locationId"] = this.locationId;
        data["locationNum"] = this.locationNum;
        data["materialId"] = this.materialId;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IWarehouseMaterialInventoryAddDTO {
    /** 所属库区id */
    areaId: string | undefined;
    /** id */
    id: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum: string | undefined;
    /** 盘点时间 */
    inventoryTime: Date | undefined;
    /** 盘点人员 */
    inventoryUser: string | undefined;
    /** 所属库位id */
    locationId: string | undefined;
    /** 库位物料数量 */
    locationNum: number | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

export class WarehouseMaterialInventoryDTO implements IWarehouseMaterialInventoryDTO {
    warehouseMaterialInventoryList!: WarehouseMaterialInventoryAddDTO[] | undefined;

    constructor(data?: IWarehouseMaterialInventoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["warehouseMaterialInventoryList"] && data["warehouseMaterialInventoryList"].constructor === Array) {
                this.warehouseMaterialInventoryList = [] as any;
                for (let item of data["warehouseMaterialInventoryList"])
                    this.warehouseMaterialInventoryList!.push(WarehouseMaterialInventoryAddDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseMaterialInventoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialInventoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.warehouseMaterialInventoryList && this.warehouseMaterialInventoryList.constructor === Array) {
            data["warehouseMaterialInventoryList"] = [];
            for (let item of this.warehouseMaterialInventoryList)
                data["warehouseMaterialInventoryList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWarehouseMaterialInventoryDTO {
    warehouseMaterialInventoryList: WarehouseMaterialInventoryAddDTO[] | undefined;
}

export class WarehouseMaterialInventoryExportResult implements IWarehouseMaterialInventoryExportResult {
    /** 失败记录数 */
    failUploadRecords!: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords!: number | undefined;
    /** 上传记录数 */
    uploadTotal!: number | undefined;

    constructor(data?: IWarehouseMaterialInventoryExportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.failUploadRecords = data["failUploadRecords"];
            this.successUploadRecords = data["successUploadRecords"];
            this.uploadTotal = data["uploadTotal"];
        }
    }

    static fromJS(data: any): WarehouseMaterialInventoryExportResult {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialInventoryExportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failUploadRecords"] = this.failUploadRecords;
        data["successUploadRecords"] = this.successUploadRecords;
        data["uploadTotal"] = this.uploadTotal;
        return data; 
    }
}

export interface IWarehouseMaterialInventoryExportResult {
    /** 失败记录数 */
    failUploadRecords: number | undefined;
    /** 成功上传记录数 */
    successUploadRecords: number | undefined;
    /** 上传记录数 */
    uploadTotal: number | undefined;
}

export class WarehouseMaterialInventoryListVO implements IWarehouseMaterialInventoryListVO {
    /** 物料条码 */
    barCode!: string | undefined;
    /** 物料编码 */
    code!: string | undefined;
    /** 误差数量 */
    errorNum!: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum!: string | undefined;
    /** 库位物料数量 */
    locationNum!: number | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 材质 */
    materialStuff!: string | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IWarehouseMaterialInventoryListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.errorNum = data["errorNum"];
            this.inventoryNum = data["inventoryNum"];
            this.locationNum = data["locationNum"];
            this.materialId = data["materialId"];
            this.materialStuff = data["materialStuff"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): WarehouseMaterialInventoryListVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialInventoryListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["errorNum"] = this.errorNum;
        data["inventoryNum"] = this.inventoryNum;
        data["locationNum"] = this.locationNum;
        data["materialId"] = this.materialId;
        data["materialStuff"] = this.materialStuff;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IWarehouseMaterialInventoryListVO {
    /** 物料条码 */
    barCode: string | undefined;
    /** 物料编码 */
    code: string | undefined;
    /** 误差数量 */
    errorNum: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum: string | undefined;
    /** 库位物料数量 */
    locationNum: number | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 材质 */
    materialStuff: string | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

export class WarehouseMaterialInventoryVO implements IWarehouseMaterialInventoryVO {
    /** 库区Id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    /** 物料条码 */
    barCode!: string | undefined;
    /** 物料编码 */
    code!: string | undefined;
    /** 误差数量 */
    errorNum!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum!: string | undefined;
    /** 盘点时间 */
    inventoryTime!: Date | undefined;
    /** 盘点人员 */
    inventoryUser!: string | undefined;
    /** 盘点人员名称 */
    inventoryUserName!: string | undefined;
    /** 同步状态，0-未同步、1-已同步 */
    isSync!: number | undefined;
    /** 库位Id */
    locationId!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库位物料数量 */
    locationNum!: number | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** stockId */
    stockId!: string | undefined;
    /** 同步时间 */
    syncTime!: Date | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IWarehouseMaterialInventoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.barCode = data["barCode"];
            this.code = data["code"];
            this.errorNum = data["errorNum"];
            this.id = data["id"];
            this.inventoryNum = data["inventoryNum"];
            this.inventoryTime = data["inventoryTime"] ? new Date(data["inventoryTime"].toString()) : <any>undefined;
            this.inventoryUser = data["inventoryUser"];
            this.inventoryUserName = data["inventoryUserName"];
            this.isSync = data["isSync"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialId = data["materialId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.standardModel = data["standardModel"];
            this.stockId = data["stockId"];
            this.syncTime = data["syncTime"] ? new Date(data["syncTime"].toString()) : <any>undefined;
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): WarehouseMaterialInventoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialInventoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["barCode"] = this.barCode;
        data["code"] = this.code;
        data["errorNum"] = this.errorNum;
        data["id"] = this.id;
        data["inventoryNum"] = this.inventoryNum;
        data["inventoryTime"] = this.inventoryTime ? this.inventoryTime.toISOString() : <any>undefined;
        data["inventoryUser"] = this.inventoryUser;
        data["inventoryUserName"] = this.inventoryUserName;
        data["isSync"] = this.isSync;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialId"] = this.materialId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["standardModel"] = this.standardModel;
        data["stockId"] = this.stockId;
        data["syncTime"] = this.syncTime ? this.syncTime.toISOString() : <any>undefined;
        data["unit"] = this.unit;
        return data; 
    }
}

export interface IWarehouseMaterialInventoryVO {
    /** 库区Id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    /** 物料条码 */
    barCode: string | undefined;
    /** 物料编码 */
    code: string | undefined;
    /** 误差数量 */
    errorNum: string | undefined;
    /** id */
    id: string | undefined;
    /** 库位物料盘点数量 */
    inventoryNum: string | undefined;
    /** 盘点时间 */
    inventoryTime: Date | undefined;
    /** 盘点人员 */
    inventoryUser: string | undefined;
    /** 盘点人员名称 */
    inventoryUserName: string | undefined;
    /** 同步状态，0-未同步、1-已同步 */
    isSync: number | undefined;
    /** 库位Id */
    locationId: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库位物料数量 */
    locationNum: number | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** stockId */
    stockId: string | undefined;
    /** 同步时间 */
    syncTime: Date | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

export class WarehouseMaterialStockDTO implements IWarehouseMaterialStockDTO {
    /** 所属库区id */
    areaId!: string | undefined;
    /** 所属库位id */
    locationId!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;

    constructor(data?: IWarehouseMaterialStockDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.locationId = data["locationId"];
            this.materialId = data["materialId"];
        }
    }

    static fromJS(data: any): WarehouseMaterialStockDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialStockDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["locationId"] = this.locationId;
        data["materialId"] = this.materialId;
        return data; 
    }
}

export interface IWarehouseMaterialStockDTO {
    /** 所属库区id */
    areaId: string | undefined;
    /** 所属库位id */
    locationId: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
}

export class WarehouseMaterialStockListDTO implements IWarehouseMaterialStockListDTO {
    /** 所属库区id集合 */
    warehouseMaterialStockDTOList!: WarehouseMaterialStockDTO[] | undefined;

    constructor(data?: IWarehouseMaterialStockListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["warehouseMaterialStockDTOList"] && data["warehouseMaterialStockDTOList"].constructor === Array) {
                this.warehouseMaterialStockDTOList = [] as any;
                for (let item of data["warehouseMaterialStockDTOList"])
                    this.warehouseMaterialStockDTOList!.push(WarehouseMaterialStockDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseMaterialStockListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialStockListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.warehouseMaterialStockDTOList && this.warehouseMaterialStockDTOList.constructor === Array) {
            data["warehouseMaterialStockDTOList"] = [];
            for (let item of this.warehouseMaterialStockDTOList)
                data["warehouseMaterialStockDTOList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWarehouseMaterialStockListDTO {
    /** 所属库区id集合 */
    warehouseMaterialStockDTOList: WarehouseMaterialStockDTO[] | undefined;
}

export class WarehouseMaterialStockListVO implements IWarehouseMaterialStockListVO {
    /** 物料编码 */
    code!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 物料库存数量 */
    locationNum!: number | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IWarehouseMaterialStockListVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.locationNum = data["locationNum"];
            this.lowerLimit = data["lowerLimit"];
            this.materialId = data["materialId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): WarehouseMaterialStockListVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseMaterialStockListVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["locationNum"] = this.locationNum;
        data["lowerLimit"] = this.lowerLimit;
        data["materialId"] = this.materialId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IWarehouseMaterialStockListVO {
    /** 物料编码 */
    code: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 物料库存数量 */
    locationNum: number | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class WarehouseStockMaterialVO implements IWarehouseStockMaterialVO {
    /** 库区Id */
    areaId!: string | undefined;
    /** 库区名称 */
    areaName!: string | undefined;
    /** 物料编码 */
    code!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue!: number | undefined;
    /** 库位Id */
    locationId!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 物料库存数量 */
    locationNum!: number | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 总库存数量 */
    stockSumNum!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IWarehouseStockMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.code = data["code"];
            this.isMustCheck = data["isMustCheck"];
            this.issue = data["issue"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.lowerLimit = data["lowerLimit"];
            this.materialId = data["materialId"];
            this.name = data["name"];
            this.remark = data["remark"];
            this.stockSumNum = data["stockSumNum"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): WarehouseStockMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseStockMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["code"] = this.code;
        data["isMustCheck"] = this.isMustCheck;
        data["issue"] = this.issue;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["lowerLimit"] = this.lowerLimit;
        data["materialId"] = this.materialId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        data["stockSumNum"] = this.stockSumNum;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IWarehouseStockMaterialVO {
    /** 库区Id */
    areaId: string | undefined;
    /** 库区名称 */
    areaName: string | undefined;
    /** 物料编码 */
    code: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue: number | undefined;
    /** 库位Id */
    locationId: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 物料库存数量 */
    locationNum: number | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 总库存数量 */
    stockSumNum: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}